import { ContactType } from './contact-type.enum';
import { UPSPickUpType } from '../../enum/general-enum';
import { Injectable } from "@angular/core";

@Injectable()
export class Location {
  ApartmentSuite?: string;
  AdditionalAddressInformation?: string;
  City?: string;
  CompanyName?: string;
  ContactId?: string;
  ContactType?: ContactType;
  Country?: string;
  CustomerId?: string;
  Email?: string;
  FaxNo?: string;
  FirstName?: string;
  IsExpress?: boolean;
  IsResidential?: boolean;
  IsUserDefault?: boolean;
  LastName?: string;
  NickName?: string;
  ProvinceRegion?: string;
  State?: string;
  StreetAddress?: string;
  TelephoneNo?: string;
  TotalContacts?: number;
  UPSLatestPickUpHour?: string;
  UPSLatestPickUpMinute?: string;
  UPSNotifyPickUpHour?: string;
  UPSNotifyPickUpMinute?: string;
  UPSPickUpType?: UPSPickUpType;
  UserId?: number;
  Zip?: string;

  // Below properties are temporary fix to a build issue.
  FaxNum?: string;
  TelNum?: string;

  VAT?: string;
  TaxID?: string;
  EORI?: string;
}
